<template>
    <div>
        <b-overlay :show="loading || processingAction" rounded="lg" opacity="0.6">
            <b-card no-body v-if="error">
                <b-alert variant="danger" show class="m-2">
                    <div class="alert-body">
                        <h4>Bir Hata Oluştu</h4>
                        <p class="mb-0">{{ error }}</p>
                    </div>
                </b-alert>
            </b-card>

            <b-card v-else-if="success" class="text-center">
                <b-alert variant="success" show class="m-2">
                    <h4>İşlem Tamamlandı</h4>
                    <p class="mb-0">{{ success }}</p>
                </b-alert>
            </b-card>

            <div v-else-if="details" no-body>
                <div class="card-header pb-0">
                    <h4>{{ ["Personel Çıkış Detayları", details.EmployeeFullName].join(" - ") }}</h4>
                    <hr />
                </div>

                <div class="card-body mt-0">
                    <SgkExitDetail :details="details" />
                    <hr />
                    <div class="text-right">
                        <button type="button" class="btn btn-danger mr-2" @click="openRejectModal" :disabled="processingAction"><b-spinner v-if="processingAction" small></b-spinner> Reddet</button>
                        <button type="button" class="btn btn-success" @click="approveExit" :disabled="processingAction"><b-spinner v-if="processingAction" small></b-spinner> Onayla</button>
                    </div>
                </div>
            </div>
        </b-overlay>

        <b-modal id="ott-reject-modal" title="Çıkış İşlemini Reddet" hide-footer no-close-on-backdrop no-close-on-esc>
            <reject-description v-model="rejectValue" />
            <div class="text-right mt-3">
                <button type="button" class="btn btn-secondary mr-2" @click="$bvModal.hide('ott-reject-modal')">İptal</button>
                <button type="button" class="btn btn-danger" @click="rejectExit" :disabled="!rejectValue.description || processingAction">
                    <b-spinner v-if="processingAction" small></b-spinner> Reddet
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { BCard, BSpinner, BAlert, BModal, BFormTextarea, BOverlay } from "bootstrap-vue";
import SGKExitApi from "@/api/sgk-exit";
import SgkExitDetail from "../sgk-exit-my-approvals/components/SGKExitDetail.vue";
import RejectDescription from "../sgk-exit-my-approvals/components/RejectDescription.vue";

export default {
    components: {
        BCard,
        BSpinner,
        BAlert,
        BOverlay,
        BModal,
        BFormTextarea,
        SgkExitDetail,
        RejectDescription,
    },
    data() {
        return {
            ott: this.$route.params.q,
            loading: true,
            error: null,
            success: null,
            details: null,
            processingAction: false,
            rejectValue: { description: null },
            GENERIC_ERROR: "İşlem tamamlanamadı. Bu link daha önce kullanılmış veya geçersiz olabilir.",
        };
    },
    mounted() {
        this.fetchDetails();
    },
    methods: {
        fetchDetails() {
            this.loading = true;
            SGKExitApi.GetTaskWithOTT(this.ott)
                .then((res) => {
                    if (res.data.Success) {
                        this.details = res.data.Data;
                    } else {
                        this.error = res.data.Message || "Geçerli bir çıkış işlemi bulunamadı veya linkin süresi dolmuş.";
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    this.error = "Bilgiler alınırken bir sunucu hatası oluştu. Lütfen tekrar deneyin.";
                    this.$result(null, err);
                    this.loading = false;
                });
        },
        changeApprovalStatus(approve, description = null) {
            this.success = null;
            this.error = null;
            this.processingAction = true;

            const payload = { OTT: this.ott, Approve: approve, Description: description };

            this.$bvModal && this.$bvModal.hide("ott-reject-modal");

            return SGKExitApi.ChangeApprovalStatusWithOTT(payload)
                .then((res) => {
                    this.$result && this.$result(res);

                    const ok = res && res.data && res.data.Success;
                    const msg = (res && res.data && res.data.Message) || this.GENERIC_ERROR;

                    if (!ok) {
                        this.error = msg;
                        return;
                    }

                    this.details = null;
                    this.success = approve ? "İşlem başarıyla onaylandı." : "İşlem başarıyla reddedildi.";
                })
                .catch((err) => {
                    this.$result && this.$result(null, err);
                    this.error = this.GENERIC_ERROR;
                })
                .finally(() => {
                    this.processingAction = false;
                });
        },

        approveExit() {
            this.changeApprovalStatus(true, null);
        },

        openRejectModal() {
            this.rejectValue = { description: null };
            this.$bvModal.show("ott-reject-modal");
        },

        rejectExit() {
            if (!this.rejectValue.description) return;
            this.changeApprovalStatus(false, this.rejectValue.description);
        },
    },
};
</script>
